<template>
  <div class="page flex-col">
    <div class="section_1 flex-col">
      <div class="block_1 flex-row">
        <img class="image_1" referrerpolicy="no-referrer" src="../../assets/img/head_logo.png" />
        <div class="nav-item active">
          <span class="nav-text ">首页</span>
          <span class="nav-line"></span>
        </div>
        <div class="nav-item" @click="goProduct()">
          <span class="nav-text">产品中心</span>
          <span class="nav-line"></span>
        </div>
        <div class="nav-item" @click="goService()">
          <span class="nav-text">服务中心</span>
          <span class="nav-line"></span>
        </div>
        <div class="nav-item" @click="goAbout()">
          <span class="nav-text">关于我们</span>
          <span class="nav-line"></span>
        </div>
        <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/head_phone.png" />
        <div class="text-wrapper_1">
          <span class="text_5">联系我们：</span>
          <span class="text_6">4000506688</span>
        </div>
      </div>
      <div class="group_12 flex-col">
        <div class="group_1 flex-col">
          <div
            class="banner-carousel"
            @mousedown="onDragStart"
            @mousemove="onDragMove"
            @mouseup="onDragEnd"
            @mouseleave="onDragEnd"
            @touchstart="onTouchStart"
            @touchmove="onTouchMove"
            @touchend="onTouchEnd"
          >
            <div
              class="banner-track"
              :class="{ 'no-transition': isTransitionDisabled }"
              :style="{ transform: `translateX(-${translateX}px)` }"
            >
              <!-- 克隆最后一个 banner（放在开头） -->
              <div class="banner_wrapper_3 flex-col banner-clone">
                <span class="text_1">科学视觉训练&nbsp;·&nbsp;衔接日常用眼场景</span>
                <div class="text-wrapper_1">
                  <span class="text_2">优眼智家</span><span class="text_3">®</span>
                  <span class="text_4">同视视觉训练仪</span>
                </div>
                <div class="image-text_1 flex-col">
                  <div class="image-text_2 flex-row">
                    <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                    <span class="paragraph_1">五大模块：调节、融像、弱视刺激、脱抑制、眼球运动</span>
                  </div>
                  <div class="image-text_2 flex-row">
                    <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                    <span class="paragraph_1">预设21种训练方案，提供个性化视觉训练方案</span>
                  </div>
                  <div class="image-text_2 flex-row">
                    <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                    <span class="paragraph_1">AI智能调节参数，训练数据云端同步</span>
                  </div>
                </div>
                <span class="text_5">训练项目：调节基础、静/动态融像、动态追踪、红绿扫描/视标、光栅、远融像（集合/散开）、调节灵活度、阶梯聚散。</span>
              </div>
              <!-- 真实的 banner 1 -->
              <div class="banner_wrapper_1 flex-col">
                <span class="text_7">深耕眼视光&nbsp;·&nbsp;智领眼健康</span>
                <span class="text_8">&nbsp;为医疗机构、视光中心及个人提供从检查到训练的一站式智能化方案</span>
              </div>
              <!-- 真实的 banner 2 -->
              <div class="banner_wrapper_2 flex-col">
                <div class="text-wrapper_1">
                  <span class="text_1">优眼智家</span><span class="text_2">®</span>
                  <span class="text_3">检训一体机</span>
                </div>
                <span class="text_4">检训一体&nbsp;·&nbsp;智慧管理&nbsp;·&nbsp;全链赋能</span>
                <div class="image-text_1 flex-col">
                  <div class="image-text_2 flex-row">
                    <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                    <span class="paragraph_1">智能融合【视功能检查】与【视觉训练】</span>
                  </div>
                  <div class="image-text_2 flex-row">
                    <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                    <span class="paragraph_1">自动流程、个性方案、智能化数据管理</span>
                  </div>
                  <div class="image-text_2 flex-row">
                    <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                    <span class="paragraph_1">助力机构搭建标准化视光服务流程</span>
                  </div>
                </div>
                <span class="text_9">可测项目：调节基础、静/动态融像、动态追踪、红绿扫描/视标、光栅、调节/聚散灵活度、正/负镜片阅读、立体视。</span>
              </div>
              <!-- 真实的 banner 3 -->
              <div class="banner_wrapper_3 flex-col">
                <span class="text_1">科学视觉训练&nbsp;·&nbsp;衔接日常用眼场景</span>
                <div class="text-wrapper_1">
                  <span class="text_2">优眼智家</span><span class="text_3">®</span>
                  <span class="text_4">同视视觉训练仪</span>
                </div>
                <div class="image-text_1 flex-col">
                  <div class="image-text_2 flex-row">
                    <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                    <span class="paragraph_1">五大模块：调节、融像、弱视刺激、脱抑制、眼球运动</span>
                  </div>
                  <div class="image-text_2 flex-row">
                    <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                    <span class="paragraph_1">预设21种训练方案，提供个性化视觉训练方案</span>
                  </div>
                  <div class="image-text_2 flex-row">
                    <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                    <span class="paragraph_1">AI智能调节参数，训练数据云端同步</span>
                  </div>
                </div>
                <span class="text_5">训练项目：调节基础、静/动态融像、动态追踪、红绿扫描/视标、光栅、远融像（集合/散开）、调节灵活度、阶梯聚散。</span>
              </div>
              <!-- 克隆第一个 banner（放在结尾） -->
              <div class="banner_wrapper_1 flex-col banner-clone">
                <span class="text_7">深耕眼视光&nbsp;·&nbsp;智领眼健康</span>
                <span class="text_8">&nbsp;为医疗机构、视光中心及个人提供从检查到训练的一站式智能化方案</span>
              </div>
            </div>
            <div class="banner-indicators">
              <span
                class="indicator"
                :class="{ active: realIndex === 0 }"
                @click="goToBanner(0)"
              ></span>
              <span
                class="indicator"
                :class="{ active: realIndex === 1 }"
                @click="goToBanner(1)"
              ></span>
              <span
                class="indicator"
                :class="{ active: realIndex === 2 }"
                @click="goToBanner(2)"
              ></span>
            </div>
          </div>
        </div>
        <div class="group_2 flex-row">
          <div class="box_1 flex-col">
            <img
              class="image_2"
              referrerpolicy="no-referrer"
              src="./assets/img/c6883faf687e9493500e88fdac451c54.png"
            />
            <span class="text_9">流程闭环</span>
            <span class="paragraph_1">
              从检查、方案设置到训练指导
              <br />
              简化工作流程，提供全周期支持
            </span>
          </div>
          <div class="box_2 flex-col">
            <img
              class="image_3"
              referrerpolicy="no-referrer"
              src="./assets/img/806b544cb9ce89a13c9b30e40f62f99a.png"
            />
            <span class="text_10">专业资质</span>
            <span class="paragraph_2">
              获批国家二类医疗器械注册证
              <br />
              专为医疗机构、视光中心设计
            </span>
          </div>
          <div class="box_3 flex-col">
            <img
              class="image_4"
              referrerpolicy="no-referrer"
              src="./assets/img/b3353867b8e80bedf80e18f4a4fe689d.png"
            />
            <span class="text_11">智能量化</span>
            <span class="paragraph_3">
              可视化报告与效果对比，
              <br />
              为临床提供客观的数据辅助工具
            </span>
          </div>
        </div>
        <div class="group_3 flex-col">
          <div class="section_2 flex-row">
            <div class="tab-item" :class="{ active: tabIndex === 1 }" @click="tabChange(1)">
              <span class="tab-text">医疗器械</span>
            </div>
            <div class="tab-item" :class="{ active: tabIndex === 2 }" @click="tabChange(2)">
              <span class="tab-text">视光产品</span>
            </div>
            <div class="tab-item" :class="{ active: tabIndex === 3 }" @click="tabChange(3)">
              <span class="tab-text">家庭健康管理</span>
            </div>
          </div>
          <!-- 医疗器械 -->
          <div v-show="tabIndex === 1" class="section_3-wrapper">
            <div class="section_3-carousel"
              @mousedown="onProductDragStart"
              @mousemove="onProductDragMove"
              @mouseup="onProductDragEnd"
              @mouseleave="onProductDragEnd"
              @touchstart="onProductTouchStart"
              @touchmove="onProductTouchMove"
              @touchend="onProductTouchEnd"
            >
              <div class="section_3-track"
                :class="{ 'no-transition': isProductTransitionDisabled }"
                :style="{ transform: `translateX(-${productTranslateX}px)` }"
              >
                <!-- 第一组产品 -->
                <div class="product-group product-group-1">
                  <div class="group_8 flex-col">
                    <div class="image-text_9 flex-col justify-between">
                      <img class="image_7" referrerpolicy="no-referrer" src="./assets/img/qx1.png" />
                      <div class="text-group_3">
                        <span class="text_20">优眼智家</span>
                        <span class="text_21">®</span>
                        <span class="text_22">同视视觉训练仪</span>
                      </div>
                    </div>
                    <div class="text-wrapper_8">
                      <span class="paragraph_6">获批第二类医疗器械注册证<br /></span>
                      <span class="text_23">五大模块+多种预设训练方案，智能数据调节</span>
                    </div>
                  </div>
                  <div class="group_8 flex-col">
                    <div class="image-text_9 flex-col justify-between">
                      <img class="image_7" referrerpolicy="no-referrer" src="./assets/img/qx2.png" />
                      <div class="text-group_3">
                        <span class="text_20">调节视功能检查仪</span>
                      </div>
                    </div>
                    <div class="text-wrapper_8">
                      <span class="paragraph_6">获批第二类医疗器械注册证<br /></span>
                      <span class="text_23">AI智能数据管理，检查过程自动判读</span>
                    </div>
                  </div>
                  <div class="group_8 flex-col">
                    <div class="image-text_9 flex-col justify-between">
                      <img class="image_7" referrerpolicy="no-referrer" src="./assets/img/qx3.png" />
                      <div class="text-group_3">
                        <span class="text_20">优眼智家</span>
                        <span class="text_21">®</span>
                        <span class="text_22">同视视觉训练仪</span>
                      </div>
                    </div>
                    <div class="text-wrapper_8">
                      <span class="paragraph_6">获批第二类医疗器械注册证<br /></span>
                      <span class="text_23">模块化集成设计，智能匹配训练难度</span>
                    </div>
                  </div>
                </div>
                <!-- 第二组产品 -->
                <div class="product-group product-group-2">
                  <div class="group_8 flex-col">
                    <div class="image-text_9 flex-col justify-between">
                      <img class="image_7" referrerpolicy="no-referrer" src="./assets/img/qx4.png" />
                      <div class="text-group_3">
                        <span class="text_20">优眼智强</span>
                        <span class="text_21">®</span>
                        <span class="text_22">视功能检查仪</span>
                      </div>
                    </div>
                    <div class="text-wrapper_8">
                      <span class="paragraph_6">获批第二类医疗器械注册证<br /></span>
                      <span class="text_23">适用于眼科常规视功能检查和屈光状态检查。</span>
                    </div>
                  </div>
                  <div class="group_8 flex-col">
                    <div class="image-text_9 flex-col justify-between">
                      <img class="image_7" referrerpolicy="no-referrer" src="./assets/img/qx5.png" />
                      <div class="text-group_3">
                        <span class="text_20">优眼智明</span>
                        <span class="text_21">®</span>
                        <span class="text_22">同视视觉训练仪</span>
                      </div>
                    </div>
                    <div class="text-wrapper_8">
                      <span class="paragraph_6">获批第二类医疗器械注册证<br /></span>
                      <span class="text_23">4大模块，语音引导，一键式自助训练</span>
                    </div>
                  </div>
                  <div class="group_8 flex-col">
                    <div class="image-text_9 flex-col justify-between">
                      <img class="image_7" referrerpolicy="no-referrer" src="./assets/img/qx6.png" />
                      <div class="text-group_3">
                        <span class="text_20">优眼智全</span>
                        <span class="text_21">®</span>
                        <span class="text_22">视功能检查仪</span>
                      </div>
                    </div>
                    <div class="text-wrapper_8">
                      <span class="paragraph_6">获批第二类医疗器械注册证<br /></span>
                      <span class="text_23">调节/聚散功能动态检查，图表化直观呈现</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="product-indicators">
                <span class="indicator" :class="{ active: productIndex === 0 }" @click="goToProduct(0)"></span>
                <span class="indicator" :class="{ active: productIndex === 1 }" @click="goToProduct(1)"></span>
              </div>
            </div>
          </div>
          <!-- 视光产品 -->
           <div v-show="tabIndex === 2" class="section_3-wrapper">
            <div class="section_3-carousel" @mousedown="onProductDragStart" @mousemove="onProductDragMove"
              @mouseup="onProductDragEnd" @mouseleave="onProductDragEnd" @touchstart="onProductTouchStart"
              @touchmove="onProductTouchMove" @touchend="onProductTouchEnd">
              <div class="section_3-track" :class="{ 'no-transition': isProductTransitionDisabled }"
                :style="{ transform: `translateX(-${productTranslateX}px)` }">
                <!-- 第一组产品 -->
                <div class="product-group product-group-1">
                  <div class="group_8 flex-col">
                    <div class="image-text_9 flex-col justify-between">
                      <img class="image_7" referrerpolicy="no-referrer" src="./assets/img/sg1.png" />
                      <div class="text-group_3">
                        <span class="text_20">优眼智家</span>
                        <span class="text_21">®</span>
                        <span class="text_22">同视视觉训练仪</span>
                      </div>
                    </div>
                    <div class="text-wrapper_8">
                      <span class="paragraph_7">AI智能匹配训练难度，支持多态化运营<br /></span>
                      <span class="text_23">适用于弱视训练、辅助治疗。</span>
                    </div>
                  </div>
                  <div class="group_8 flex-col">
                    <div class="image-text_9 flex-col justify-between">
                      <img class="image_7" referrerpolicy="no-referrer" src="./assets/img/sg2.png" />
                      <div class="text-group_3">
                        <span class="text_20">优眼智家</span>
                        <span class="text_21">®</span>
                        <span class="text_22">检训一体机</span>
                      </div>
                    </div>
                    <div class="text-wrapper_8">
                      <span class="paragraph_7">智能融合 视功能检查与视觉训练功能<br /></span>
                      <span class="text_23">支持近视干预管理、斜弱视等日常视觉训练场景</span>
                    </div>
                  </div>
                  <div class="group_8 flex-col">
                    <div class="image-text_9 flex-col justify-between">
                      <img class="image_7" referrerpolicy="no-referrer" src="./assets/img/sg3.png" />
                      <div class="text-group_3">
                        <span class="text_20">优眼智家</span>
                        <span class="text_21">®</span>
                        <span class="text_22">智能眼力仪</span>
                      </div>
                    </div>
                    <div class="text-wrapper_8">
                      <span class="paragraph_7">智能方案一键预设，镜盘全自动切换<br/></span>
                      <span class="text_23">日常双眼视觉健康管理与视觉训练辅助</span>
                    </div>
                  </div>
                </div>
                <!-- 第二组产品 -->
                <div class="product-group product-group-2">
                  <div class="group_8 flex-col">
                    <div class="image-text_9 flex-col justify-between">
                      <img class="image_7" referrerpolicy="no-referrer" src="./assets/img/sg4.png" />
                      <div class="text-group_3">
                        <span class="text_20">优眼智家</span>
                        <span class="text_21">®</span>
                        <span class="text_22">同视视觉训练仪</span>
                      </div>
                    </div>
                    <div class="text-wrapper_8">
                      <span class="paragraph_7">AI智能匹配训练难度，支持多态化运营<br/></span>
                      <span class="text_23">用于弱视觉视训练、调节功能改善等</span>
                    </div>
                  </div>
                  <div class="group_8 flex-col">
                    <div class="image-text_9 flex-col justify-between">
                      <img class="image_7" referrerpolicy="no-referrer" src="./assets/img/sg5.png" />
                      <div class="text-group_3">
                        <span class="text_20">调节视功能检查仪（视光版）</span>
                      </div>
                    </div>
                    <div class="text-wrapper_8">
                      <span class="paragraph_7">检查过程自动判读、动态跟踪记录<br /></span>
                      <span class="text_23">助力视光师直观评估视功能状况</span>
                    </div>
                  </div>
                  <div class="group_8 flex-col">
                    <div class="image-text_9 flex-col justify-between">
                      <img class="image_7" referrerpolicy="no-referrer" src="./assets/img/sg6.png" />
                      <div class="text-group_3">
                        <span class="text_20">优眼智家</span>
                        <span class="text_21">®</span>
                        <span class="text_22">视觉功能训练一体机</span>
                      </div>
                    </div>
                    <div class="text-wrapper_8">
                      <span class="paragraph_7">专业视觉训练与游戏化体验深度融合<br /></span>
                      <span class="text_23">辅助提升调节力、集合力及立体视等</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="product-indicators">
                <span class="indicator" :class="{ active: productIndex === 0 }" @click="goToProduct(0)"></span>
                <span class="indicator" :class="{ active: productIndex === 1 }" @click="goToProduct(1)"></span>
              </div>
            </div>
          </div>
          <!-- 家庭健康管理 -->
           <div v-show="tabIndex === 3" class="section_3-wrapper">
            <div class="section_3-carousel" @mousedown="onProductDragStart" @mousemove="onProductDragMove"
              @mouseup="onProductDragEnd" @mouseleave="onProductDragEnd" @touchstart="onProductTouchStart"
              @touchmove="onProductTouchMove" @touchend="onProductTouchEnd">
              <div class="section_3-track" :class="{ 'no-transition': isProductTransitionDisabled }"
                :style="{ transform: `translateX(-${productTranslateX}px)` }">
                <!-- 第一组产品 -->
                <div class="product-group product-group-1">
                  <div class="group_8 flex-col">
                    <div class="image-text_9 flex-col justify-between">
                      <img class="image_7 image_7_none" referrerpolicy="no-referrer" src="./assets/img/jt1.png" />
                      <div class="text-group_3">
                        <span class="text_20">气压眼部按摩仪</span>
                      </div>
                    </div>
                    <div class="text-wrapper_8">
                      <span class="paragraph_7 ">恒温热敷、气压按摩、3D可视、内置音乐<br /></span>
                      <span class="text_23">缓解日常用眼疲劳、干涩及黑眼圈</span>
                    </div>
                  </div>
                  <div class="group_8 flex-col">
                    <div class="image-text_9 flex-col justify-between">
                      <img class="image_7 image_7_none" referrerpolicy="no-referrer" src="./assets/img/jt2.png" />
                      <div class="text-group_3">
                        <span class="text_20">智能眼健康训练仪</span>
                      </div>
                    </div>
                    <div class="text-wrapper_8">
                      <span class="paragraph_7">全自动视功能训练，智能翻转设计<br /></span>
                      <span class="text_23">适用于家庭场景下的自主眼健康管理</span>
                    </div>
                  </div>
                  <div class="group_8 flex-col">
                    <div class="image-text_9 flex-col justify-between">
                      <img class="image_7 image_7_none" referrerpolicy="no-referrer" src="./assets/img/jt3.png" />
                      <div class="text-group_3">
                        <span class="text_20">视觉功能训练一体机</span>
                      </div>
                    </div>
                    <div class="text-wrapper_8">
                      <span class="paragraph_7">专业视觉训练与游戏化体验深度融合<br /></span>
                      <span class="text_23">辅助提升调节力、集合力及立体视等</span>
                    </div>
                  </div>
                </div>
                <!-- 第二组产品 -->
                <div class="product-group product-group-2">
                  <div class="group_8 flex-col">
                    <div class="image-text_9 flex-col justify-between">
                      <img class="image_7 image_7_none" referrerpolicy="no-referrer" src="./assets/img/jt4.png" />
                      <div class="text-group_3">
                        <span class="text_20">智能眼力仪</span>
                      </div>
                    </div>
                    <div class="text-wrapper_8">
                      <span class="paragraph_7">智能方案预设，镜盘自动切换<br /></span>
                      <span class="text_23">日常双眼视觉健康管理与视觉训练辅助</span>
                    </div>
                  </div>
                  <div class="group_8 flex-col">
                    <div class="image-text_9 flex-col justify-between">
                      <img class="image_7 image_7_none" referrerpolicy="no-referrer" src="./assets/img/jt5.png" />
                      <div class="text-group_3">
                        <span class="text_20">脑视觉训练软件</span>
                      </div>
                    </div>
                    <div class="text-wrapper_8">
                      <span class="paragraph_7">将专业视觉训练内容转化为互动游戏<br /></span>
                      <span class="text_23">支持同时视、融合视、立体视等功能训练</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="product-indicators">
                <span class="indicator" :class="{ active: productIndex === 0 }" @click="goToProduct(0)"></span>
                <span class="indicator" :class="{ active: productIndex === 1 }" @click="goToProduct(1)"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="group_9 flex-col">
          <div class="block_4 flex-row justify-between">
            <div class="text-wrapper_9 flex-col"><span class="text_24">30+</span></div>
            <div class="text-wrapper_10 flex-col"><span class="text_25">800+</span></div>
            <div class="text-wrapper_11 flex-col"><span class="text_26">1100+</span></div>
            <div class="text-wrapper_12 flex-col"><span class="text_27">100W+</span></div>
          </div>
          <div class="text-wrapper_18 flex-row justify-between">
            <span class="text_28">服务地区</span>
            <span class="text_29">合作医院</span>
            <span class="text_30">合作机构</span>
            <span class="text_31">服务人次</span>
          </div>
          <div class="text-wrapper_19 flex-row">
            <span class="text_32">数据截至2025年11月，来源于公司内部统计</span>
          </div>
        </div>
        <div class="image-wrapper_2 flex-col">
          <img
            class="image_9"
            referrerpolicy="no-referrer"
            src="./assets/img/1de9c35675eb9e8518c407becfa37c03.png"
          />
        </div>
        <div class="group_11 flex-col justify-end">
          <div class="image-text_10 flex-col justify-between">
            <div class="text-wrapper_15 flex-col"><span class="text_33">关于优眼</span></div>
            <span class="text-group_4">智能视觉健康服务解决方案供应商</span>
          </div>
          <img
            class="image_10"
            referrerpolicy="no-referrer"
            src="./assets/img/4a1204ebc4f9505cf7c4e5bd8895c0b6.png"
          />
          <div class="text-wrapper_16">
            <span class="paragraph_7">
              天津新视光技术有限公司是乐普医疗（股票代码：300003）旗下子公司，是智能视觉健康服务解决方案服务商。依托物联网、人工智能及云服务技术，致力于视功能诊疗产品的研发与生产。
              <br />
              以
            </span>
            <span class="text_34">【优眼】</span>
            <span class="text_35">系列为核心，为医疗机构、视光中心及个人提供从</span>
            <span class="text_36">视功能检查</span>
            <span class="text_37">到</span>
            <span class="text_38">视觉训练</span>
            <span class="text_39">
              的一站式智能化解决方案，通过自动化检查流程与标准化数据管理，助力功能性眼病的规范化诊疗。
            </span>
          </div>
        </div>
      </div>
      <div class="bottom_box flex-row">
        <img
          class="image_11"
          referrerpolicy="no-referrer"
          src="../../assets/img/bottom_phone.png"
        />
        <div class="text-wrapper_20 flex-col justify-between">
          <span class="text_40">联系我们：</span>
          <span class="text_41">400&nbsp;050&nbsp;6688</span>
          <div class="network-keycord">津ICP备2021007957号-1</div>
        </div>
        <div class="image-text_11 flex-col justify-between">
          <img
            class="image_12"
            referrerpolicy="no-referrer"
            src="../../assets/img/bottom_ercode1.png"
          />
          <span class="text-group_5">视频号</span>
        </div>
        <div class="image-text_12 flex-col justify-between">
          <img
            class="image_13"
            referrerpolicy="no-referrer"
            src="../../assets/img/bottom_ercode2.png"
          />
          <span class="text-group_6">公众号</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {},
      tabIndex: 1,
      currentIndex: 1,
      translateX: 0,
      isTransitionDisabled: false,
      bannerTimer: null,
      // 滑动相关
      isDragging: false,
      startX: 0,
      dragOffset: 0,
      bannerWidth: 0,
      // 产品滑动相关
      productIndex: 0,
      productTranslateX: 0,
      isProductTransitionDisabled: false,
      isProductDragging: false,
      productStartX: 0,
      productDragOffset: 0,
      productGroupWidth: 0
    };
  },
  computed: {
    realIndex() {
      if (this.currentIndex === 0) return 2;
      if (this.currentIndex === 4) return 0;
      return this.currentIndex - 1;
    }
  },
  mounted() {
    this.bannerWidth = window.innerWidth;
    this.translateX = this.bannerWidth;
    this.productGroupWidth = window.innerWidth * 0.6237; // 62.37vw
    this.productTranslateX = 0;
    this.startBannerTimer();
    window.addEventListener('resize', this.onResize);
    // 注入结构化数据
    this.injectStructuredData();
  },
  beforeDestroy() {
    this.stopBannerTimer();
    window.removeEventListener('resize', this.onResize);
    // 移除结构化数据
    this.removeStructuredData();
  },
  methods: {
    // 注入结构化数据（JSON-LD）供 AI 爬虫抓取
    injectStructuredData() {
      // 面包屑导航结构化数据
      const breadcrumbData = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "首页",
            "item": "https://test.uyu.com/uyu_home"
          }
        ]
      };

      // 网站结构化数据
      const websiteData = {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "优眼智家官网",
        "url": "https://test.uyu.com",
        "description": "优眼智家专注于视功能检查与训练设备的研发与生产，提供智能眼健康解决方案",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://test.uyu.com/uyu_product",
          "query-input": "required name=search_term_string"
        }
      };

      // 主页结构化数据
      const mainPageData = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "优眼智家首页",
        "url": "https://test.uyu.com/uyu_home",
        "description": "优眼智家首页 - 深耕眼视光，智领眼健康。为医疗机构、视光中心及个人提供从检查到训练的一站式智能化方案。",
        "isPartOf": {
          "@type": "WebSite",
          "name": "优眼智家官网",
          "url": "https://test.uyu.com"
        },
        "mainEntity": {
          "@type": "Organization",
          "name": "天津新视光技术有限公司",
          "alternateName": "优眼智家",
          "url": "https://test.uyu.com",
          "description": "乐普医疗旗下子公司，智能视觉健康服务解决方案服务商",
          "telephone": "400-050-6688",
          "address": {
            "@type": "PostalAddress",
            "addressCountry": "CN",
            "addressLocality": "天津"
          },
          "parentOrganization": {
            "@type": "Organization",
            "name": "乐普医疗",
            "tickerSymbol": "300003"
          }
        }
      };

      // 医疗器械产品列表
      const medicalDeviceProducts = [
        {
          "@type": "Product",
          "name": "优眼智家®同视视觉训练仪",
          "description": "获批第二类医疗器械注册证。五大模块+多种预设训练方案，智能数据调节。训练项目包括调节基础、静/动态融像、动态追踪、红绿扫描/视标、光栅、远融像、调节灵活度、阶梯聚散。",
          "category": "医疗器械",
          "brand": {
            "@type": "Brand",
            "name": "优眼智家"
          }
        },
        {
          "@type": "Product",
          "name": "调节视功能检查仪",
          "description": "获批第二类医疗器械注册证。AI智能数据管理，检查过程自动判读，动态跟踪记录。",
          "category": "医疗器械",
          "brand": {
            "@type": "Brand",
            "name": "优眼智家"
          }
        },
        {
          "@type": "Product",
          "name": "优眼智强®视功能检查仪",
          "description": "获批第二类医疗器械注册证。适用于眼科常规视功能检查和屈光状态检查。",
          "category": "医疗器械",
          "brand": {
            "@type": "Brand",
            "name": "优眼智强"
          }
        },
        {
          "@type": "Product",
          "name": "优眼智明®同视视觉训练仪",
          "description": "获批第二类医疗器械注册证。4大模块，语音引导，一键式自助训练。",
          "category": "医疗器械",
          "brand": {
            "@type": "Brand",
            "name": "优眼智明"
          }
        },
        {
          "@type": "Product",
          "name": "优眼智全®视功能检查仪",
          "description": "获批第二类医疗器械注册证。调节/聚散功能动态检查，图表化直观呈现。",
          "category": "医疗器械",
          "brand": {
            "@type": "Brand",
            "name": "优眼智全"
          }
        },
        {
          "@type": "Product",
          "name": "优眼智家®检训一体机",
          "description": "智能融合视功能检查与视觉训练。检训一体，智慧管理，全链赋能。自动流程、个性方案、智能化数据管理。可测项目包括调节基础、静/动态融像、动态追踪、红绿扫描/视标、光栅、调节/聚散灵活度、正/负镜片阅读、立体视。",
          "category": "医疗器械",
          "brand": {
            "@type": "Brand",
            "name": "优眼智家"
          }
        }
      ];

      // 产品列表结构化数据
      const productListData = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        "name": "优眼智家产品列表",
        "description": "优眼智家专业视功能检查与训练设备产品列表",
        "numberOfItems": medicalDeviceProducts.length,
        "itemListElement": medicalDeviceProducts.map((product, index) => ({
          "@type": "ListItem",
          "position": index + 1,
          "item": product
        }))
      };

      // 服务数据
      const serviceData = {
        "@context": "https://schema.org",
        "@type": "Service",
        "name": "优眼智家眼健康服务",
        "description": "为医疗机构、视光中心及个人提供从视功能检查到视觉训练的一站式智能化解决方案",
        "provider": {
          "@type": "Organization",
          "name": "天津新视光技术有限公司",
          "telephone": "400-050-6688"
        },
        "serviceType": "眼健康管理服务",
        "areaServed": {
          "@type": "Country",
          "name": "中国"
        },
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "眼健康服务",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "视功能检查服务"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "视觉训练服务"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "眼健康咨询服务"
              }
            }
          ]
        }
      };

      // FAQ 结构化数据
      const faqData = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "优眼智家是做什么的？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "天津新视光技术有限公司是乐普医疗旗下子公司，是智能视觉健康服务解决方案服务商。依托物联网、人工智能及云服务技术，致力于视功能诊疗产品的研发与生产。以【优眼】系列为核心，为医疗机构、视光中心及个人提供从视功能检查到视觉训练的一站式智能化解决方案。"
            }
          },
          {
            "@type": "Question",
            "name": "优眼智家的产品有哪些资质？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "优眼智家的多项产品已获批国家二类医疗器械注册证，专为医疗机构、视光中心设计，具备专业资质认证。"
            }
          },
          {
            "@type": "Question",
            "name": "优眼智家服务了多少客户？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "截至2025年11月，优眼智家已服务30+地区、800+合作医院、1100+合作机构、100万+服务人次。"
            }
          },
          {
            "@type": "Question",
            "name": "如何联系优眼智家？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "您可以拨打客服热线400-050-6688联系我们，或关注我们的视频号和公众号获取更多信息。"
            }
          },
          {
            "@type": "Question",
            "name": "优眼智家的产品有哪些？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "优眼智家提供三大类产品：医疗器械类（同视视觉训练仪、检训一体机、调节视功能检查仪、屈光视功能检查仪等）、视光产品类（智能眼力仪、视觉功能训练一体机等）、家庭健康管理类（气压眼部按摩仪、智能眼健康训练仪、脑视觉训练软件等）。"
            }
          }
        ]
      };

      // 统计数据
      const statisticsData = {
        "@context": "https://schema.org",
        "@type": "Dataset",
        "name": "优眼智家服务统计数据",
        "description": "优眼智家截至2025年11月的服务统计数据",
        "distribution": {
          "@type": "DataDownload",
          "name": "服务统计",
          "contentUrl": "https://test.uyu.com/uyu_home"
        },
        "variablesMeasured": [
          {
            "@type": "PropertyValue",
            "name": "服务地区数量",
            "value": "30+"
          },
          {
            "@type": "PropertyValue",
            "name": "合作医院数量",
            "value": "800+"
          },
          {
            "@type": "PropertyValue",
            "name": "合作机构数量",
            "value": "1100+"
          },
          {
            "@type": "PropertyValue",
            "name": "服务人次",
            "value": "100万+"
          }
        ]
      };

      // 注入所有结构化数据到 head
      const structuredDataList = [
        { id: 'breadcrumb', data: breadcrumbData },
        { id: 'website', data: websiteData },
        { id: 'mainpage', data: mainPageData },
        { id: 'productlist', data: productListData },
        { id: 'service', data: serviceData },
        { id: 'faq', data: faqData },
        { id: 'statistics', data: statisticsData }
      ];

      structuredDataList.forEach(item => {
        const script = document.createElement('script');
        script.id = `structured-data-${item.id}`;
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify(item.data);
        document.head.appendChild(script);
      });
    },
    // 移除结构化数据
    removeStructuredData() {
      const ids = ['breadcrumb', 'website', 'mainpage', 'productlist', 'service', 'faq', 'statistics'];
      ids.forEach(id => {
        const script = document.getElementById(`structured-data-${id}`);
        if (script) {
          document.head.removeChild(script);
        }
      });
    },
    goProduct() {
      this.$router.push('/uyu_product')
      // window.open(route.href, '_blank')
    },
    goService() {
      this.$router.push('/uyu_service')
    },
    goAbout() {
      this.$router.push('/uyu_about')
    },
    tabChange(index) {
      this.tabIndex = index;
      this.productIndex = 0;
    },
    onResize() {
      this.bannerWidth = window.innerWidth;
      this.translateX = this.currentIndex * this.bannerWidth;
      this.productGroupWidth = window.innerWidth * 0.6237;
      this.productTranslateX = this.productIndex * this.productGroupWidth;
    },
    startBannerTimer() {
      this.bannerTimer = setInterval(() => {
        this.nextBanner();
      }, 5000);
    },
    stopBannerTimer() {
      if (this.bannerTimer) {
        clearInterval(this.bannerTimer);
        this.bannerTimer = null;
      }
    },
    nextBanner() {
      this.currentIndex++;
      this.translateX = this.currentIndex * this.bannerWidth;
      this.checkBoundary();
    },
    prevBanner() {
      this.currentIndex--;
      this.translateX = this.currentIndex * this.bannerWidth;
      this.checkBoundary();
    },
    checkBoundary() {
      setTimeout(() => {
        if (this.currentIndex === 0) {
          this.isTransitionDisabled = true;
          this.currentIndex = 3;
          this.translateX = this.currentIndex * this.bannerWidth;
          setTimeout(() => {
            this.isTransitionDisabled = false;
          }, 50);
        } else if (this.currentIndex === 4) {
          this.isTransitionDisabled = true;
          this.currentIndex = 1;
          this.translateX = this.currentIndex * this.bannerWidth;
          setTimeout(() => {
            this.isTransitionDisabled = false;
          }, 50);
        }
      }, 600);
    },
    goToBanner(index) {
      this.stopBannerTimer();
      this.currentIndex = index + 1;
      this.translateX = this.currentIndex * this.bannerWidth;
      this.startBannerTimer();
    },
    onDragStart(e) {
      this.isDragging = true;
      this.startX = e.clientX;
      this.stopBannerTimer();
    },
    onDragMove(e) {
      if (!this.isDragging) return;
      this.dragOffset = e.clientX - this.startX;
      this.translateX = this.currentIndex * this.bannerWidth - this.dragOffset;
    },
    onDragEnd() {
      if (!this.isDragging) return;
      this.isDragging = false;
      const threshold = this.bannerWidth * 0.2;
      if (this.dragOffset > threshold) {
        this.prevBanner();
      } else if (this.dragOffset < -threshold) {
        this.nextBanner();
      } else {
        this.translateX = this.currentIndex * this.bannerWidth;
      }
      this.dragOffset = 0;
      this.startBannerTimer();
    },
    onTouchStart(e) {
      this.isDragging = true;
      this.startX = e.touches[0].clientX;
      this.stopBannerTimer();
    },
    onTouchMove(e) {
      if (!this.isDragging) return;
      this.dragOffset = e.touches[0].clientX - this.startX;
      this.translateX = this.currentIndex * this.bannerWidth - this.dragOffset;
    },
    onTouchEnd() {
      if (!this.isDragging) return;
      this.isDragging = false;
      const threshold = this.bannerWidth * 0.2;
      if (this.dragOffset > threshold) {
        this.prevBanner();
      } else if (this.dragOffset < -threshold) {
        this.nextBanner();
      } else {
        this.translateX = this.currentIndex * this.bannerWidth;
      }
      this.dragOffset = 0;
      this.startBannerTimer();
    },
    // 产品滑动方法
    goToProduct(index) {
      this.productIndex = index;
      this.productTranslateX = index * this.productGroupWidth;
    },
    nextProduct() {
      if (this.productIndex < 1) {
        this.productIndex++;
        this.productTranslateX = this.productIndex * this.productGroupWidth;
      }
    },
    prevProduct() {
      if (this.productIndex > 0) {
        this.productIndex--;
        this.productTranslateX = this.productIndex * this.productGroupWidth;
      }
    },
    onProductDragStart(e) {
      this.isProductDragging = true;
      this.productStartX = e.clientX;
    },
    onProductDragMove(e) {
      if (!this.isProductDragging) return;
      this.productDragOffset = e.clientX - this.productStartX;
      this.productTranslateX = this.productIndex * this.productGroupWidth - this.productDragOffset;
    },
    onProductDragEnd() {
      if (!this.isProductDragging) return;
      this.isProductDragging = false;
      const threshold = this.productGroupWidth * 0.2;
      if (this.productDragOffset > threshold) {
        this.prevProduct();
      } else if (this.productDragOffset < -threshold) {
        this.nextProduct();
      } else {
        this.productTranslateX = this.productIndex * this.productGroupWidth;
      }
      this.productDragOffset = 0;
    },
    onProductTouchStart(e) {
      this.isProductDragging = true;
      this.productStartX = e.touches[0].clientX;
    },
    onProductTouchMove(e) {
      if (!this.isProductDragging) return;
      this.productDragOffset = e.touches[0].clientX - this.productStartX;
      this.productTranslateX = this.productIndex * this.productGroupWidth - this.productDragOffset;
    },
    onProductTouchEnd() {
      if (!this.isProductDragging) return;
      this.isProductDragging = false;
      const threshold = this.productGroupWidth * 0.2;
      if (this.productDragOffset > threshold) {
        this.prevProduct();
      } else if (this.productDragOffset < -threshold) {
        this.nextProduct();
      } else {
        this.productTranslateX = this.productIndex * this.productGroupWidth;
      }
      this.productDragOffset = 0;
    }
  }
};
</script>
<style scoped lang="less" src="./assets/index.response.less" />